// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CUhDabdF2kWLY9aQ9JXb {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    & > div {
        box-shadow: none;
    }
}

.T1l0LXZ52N5noECEpvH2 {
    height: 100%;
    margin-bottom: 2.5rem;
    text-align: center;
}

.jpPohnN0Lg0yUhDV6LhR {
    height: 100%;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ControlCodeBase/ControlCodeBase.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;;IAEV;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B","sourcesContent":[".card-container {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n\n    & > div {\n        box-shadow: none;\n    }\n}\n\n.code-container {\n    height: 100%;\n    margin-bottom: 2.5rem;\n    text-align: center;\n}\n\n.code-container-inner {\n    height: 100%;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `CUhDabdF2kWLY9aQ9JXb`,
	"codeContainer": `T1l0LXZ52N5noECEpvH2`,
	"codeContainerInner": `jpPohnN0Lg0yUhDV6LhR`
};
module.exports = ___CSS_LOADER_EXPORT___;
